export type ImageCropTransformations = {
  crop: boolean | { aspectRatio?: number; force?: boolean }
  circle?: boolean
}

/**
 * Build Filestack picker transformations for image uploads.
 *
 * - No aspectRatio: freeform rectangle crop (side + corner handles). User can pick square,
 *   portrait, landscape, or any ratio. Crop step is still required before upload.
 * - With aspectRatio: locked ratio (e.g. service card photos, headshots).
 */
export function buildImageCropTransformations(aspectRatio?: number | null): ImageCropTransformations {
  if (aspectRatio == null) {
    return { crop: { force: true }, circle: false }
  }

  return { crop: { aspectRatio, force: true }, circle: false }
}
